<div class="page-title">
  <div [innerHTML]="'PersonalInfo.Second.Title' | translate" class="title"></div>
  <div [innerHTML]="'PersonalInfo.Second.SubTitle' | translate" class="sub-title"></div>
</div>

<app-personal
  (userModelChange)="updateUser()"
  [(userModel)]="user.secondHolder"
  [forbiddenEmails]="[user.email]"
  [forbiddenPhones]="[user.phone]"
  [isSecondFolder]="true"
  [requiredPhone]="true"
></app-personal>
